import React from "react";
import { Box, Flex, Image, Text as CText, IconButton, Spinner, Tooltip, useClipboard } from "@chakra-ui/react";
import { CopyIcon, CheckIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";

import { Icon } from "ui-kit";
// TODO: Issue MRP-2775
// eslint-disable-next-line import/no-unresolved
import { ArrowRight, GiftCard } from "ui-kit/icon";
import { ReferFriend as refer } from "static/images";

const ReferralContent = ({ isLoading, shareUrl, hasCopied, onCopy, onReferClick }) => {
  if (isLoading) {
    return (
      <Flex align="center" justify="center" py="2">
        <Spinner size="sm" color="#0A92B8" />
      </Flex>
    );
  }

  if (shareUrl) {
    return (
      <Flex align="center" gap="2">
        <Flex
          align="center"
          bg="white"
          border="1px solid #C4DDE3"
          borderRadius="md"
          px="3"
          py="2"
          h="36px"
          flex="1"
          overflow="hidden"
        >
          <CText fontSize="13px" color="#2D3848" isTruncated>
            {shareUrl}
          </CText>
        </Flex>
        <Tooltip label={hasCopied ? "Copied!" : "Copy link"} placement="top" hasArrow>
          <IconButton
            aria-label="Copy referral link"
            icon={hasCopied ? <CheckIcon color="white" /> : <CopyIcon color="white" />}
            size="sm"
            minW="36px"
            h="36px"
            bg="#0A92B8"
            borderRadius="md"
            flexShrink={0}
            _hover={{ bg: "#087E9E" }}
            onClick={onCopy}
          />
        </Tooltip>
      </Flex>
    );
  }

  return (
    <Box
      as="button"
      onClick={onReferClick}
      display="flex"
      alignItems="center"
      gap="2px"
      background="none"
      border="none"
      padding="0"
      cursor="pointer"
    >
      <CText fontSize="14px" fontWeight="500" color="#086883" textDecoration="underline">
        Refer Here
      </CText>
    </Box>
  );
};

const LegacyFeaturePanel = () => (
  <Flex flexDir="row" shadow="0 -3pt 6pt hsla(0, 0%, 0%, 0.1)" borderTopRadius="10px">
    <Link to="/refer-friend/" style={{ width: "234px", height: "123px" }}>
      <Image src={refer} alt="Refer logo" width="134px" height="123px" borderTopRightRadius="8px" />
    </Link>
    <Box color="blue.darkest" padding="12px 26px 0px 20px" letterSpacing="0px">
      <CText fontSize="10px" lineHeight="12.5px" fontWeight="500" color="#6F7F98">
        NEW
      </CText>
      <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#2D3848">
        $100 Awaits You!
      </CText>
      <CText fontSize="14px" lineHeight="20px" fontWeight="500" color="#00252F" opacity="0.5">
        Refer your friends to us, get rewarded.
      </CText>
      <Link to="/refer-friend/">
        <Box display="flex" alignItems="center" marginBottom="6px" gap="2px">
          <CText fontSize="14px" fontWeight="500" color="#086883" textDecoration="underline">
            Refer Here
          </CText>
          <Box as={ArrowRight} width="7.5px" height="6.43" />
        </Box>
      </Link>
    </Box>
  </Flex>
);

const NewFeaturePanel = ({ onReferClick, shareUrl, isLoading }) => {
  const { hasCopied, onCopy } = useClipboard(shareUrl || "");

  if (!onReferClick) {
    return <LegacyFeaturePanel />;
  }

  return (
    <Flex
      flexDir="column"
      gap="2"
      shadow="0 -3pt 6pt hsla(0, 0%, 0%, 0.1)"
      borderTopRadius="10px"
      p="4"
      bg="#E6F4F8"
      border="1px solid #9DD6E2"
    >
      <Flex align="center" gap="2">
        <Icon as={GiftCard} boxSize="5" color="#0A92B8" flexShrink={0} />
        <CText fontSize="14px" lineHeight="20px" fontWeight="600" color="#0A92B8">
          Refer a friend<br/>Earn $100 for each referral, it's easy as one click
        </CText>
      </Flex>

      <ReferralContent
        isLoading={isLoading}
        shareUrl={shareUrl}
        hasCopied={hasCopied}
        onCopy={onCopy}
        onReferClick={onReferClick}
      />
    </Flex>
  );
};

export default NewFeaturePanel;
